import React from "react";

export default class Tr extends React.Component {
  render() {
    return <tr>{this.props.children}</tr>;
  }
}
